import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
      <div className="max-w-md mx-auto px-4 text-center">
        <div className="w-20 h-20 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-10 h-10 text-red-500" />
        </div>
        <h1 className="font-heading text-3xl font-bold text-white uppercase mb-4">
          Payment Cancelled
        </h1>
        <p className="text-gray-400 mb-8">
          Your payment was cancelled. No charges were made. You can try again when you're ready.
        </p>

        <div className="flex flex-col gap-3">
          <Link to="/portal">
            <Button className="btn-primary w-full" data-testid="back-portal-btn">
              Back to Portal
            </Button>
          </Link>
          <Link to="/">
            <Button variant="outline" className="w-full border-[#404040] text-white hover:bg-[#262626]">
              Back to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
